import { newAppliance } from './appliance'

export const defaultVariation = (defaultLocale, appliances) => ({
  cookTimeMinutes: 0,
  preparationTimeMinutes: 0,
  restTimeMinutes: 0,

  hasBrowningLevel: true,
  browning: {
    minLevel: 20,
    maxLevel: 80,
    translates: {
      defaultLabels: true,
    },
  },

  translates: {
    [defaultLocale]: {
      variant: 'Main Course',
    },
  },

  hasCookingLevel: false,
  cooking: {
    minLevel: 20,
    maxLevel: 80,
    translates: {
      defaultLabels: true,
    },
  },

  hasTime: false,

  sections: [],

  applianceSteps: {
    [appliances[0].id]: newAppliance(defaultLocale),
  },
})
